import React, { useEffect, useState } from "react";
import Button from "../../../../components/Button/Button";
import "./skills.scss";
import { useDispatch, useSelector } from "react-redux";
import { useUpdatePartnerSkills } from "../../../../hooks/partnerHook/useSkills";
import { closeSkills } from "../../../../store/Partner/modalSlice";

export default function MySkills() {
    const [groupedSkills, setGroupedSkills] = useState({});
    const [userSkills, setUserSkills] = useState([]);
    const allSkills = useSelector((state) => state.siteData.partnerSkills);
    const partnerAlreadySkill = useSelector((state) => state.partner.user.partner.skills);
    console.log(partnerAlreadySkill)
    const dispatch = useDispatch();
    
    useEffect(() => {
        if (partnerAlreadySkill?.length) {
            setUserSkills(partnerAlreadySkill);
        }
    }, [partnerAlreadySkill]);
    

    useEffect(() => {
        const grouped = groupSkillsByCategory(allSkills);
        setGroupedSkills(grouped);
    }, [allSkills]);

    const groupSkillsByCategory = (skills) => {
        const grouped = {};
        skills.forEach((skill) => {
            if (!grouped[skill.skill_category]) {
                grouped[skill.skill_category] = [];
            }
            grouped[skill.skill_category].push(skill);
        });
        return grouped;
    };

    const handleSkillClick = (skill) => {
        setUserSkills((prevSkills) => {
            const isSelected = prevSkills.some((s) => s.skill_id === skill.skill_id);
            if (isSelected) {
                return prevSkills.filter((s) => s.skill_id !== skill.skill_id);
            } else {
                return [...prevSkills, skill];
            }
        });
    };
    const { mutate, isSuccess, isError, isPending } = useUpdatePartnerSkills()
    const handleSkillSubmission = async () => {
        try {
            console.log("Selected Skills:", userSkills);
            mutate(userSkills)
        } catch (error) {
            console.error("Error submitting skills:", error);
        }
    };
    
    // Modal Close
    const handleCloseSkills = () => {
        dispatch(closeSkills())
    }
    useEffect(() => {
        if(isSuccess){
            handleCloseSkills();
            }
    }, [isSuccess])

    return (
        <div className="container-background content-center">
            <div className="skills-container">
                <div className="close-btn-skills">
                    <Button label={'Close'} customStyle={{ background: '#FF5757', color: 'white' }} handleClick={handleCloseSkills} />
                </div>
                <div className="page-header">
                    <h2 className="page-heading">Choose Your Skills</h2>
                    <p className="page-sub-heading">Select up to 3 skills to help clients find your service</p>
                </div>
                <div className="skills-list">
                    <div className="skills">
                        {Object.keys(groupedSkills).map((category, index) => (
                            <div key={index}>
                                <div className="skills-category-header">
                                    <h3>{category}</h3>
                                </div>
                                <div className="sub-skills-container">
                                    {groupedSkills[category].map((skill) => (
                                        <p
                                            key={skill.skill_id} 
                                            className={userSkills.some((s) => s.skill_id === skill.skill_id) ? 'selected-role' : ""}
                                            data-id={skill.skill_id}
                                            onClick={() => handleSkillClick(skill)}
                                        >
                                            {skill.skill_name}
                                        </p>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="skills-btn-container">
                        <Button
                            className={userSkills.length > 0 ? 'save-skills-btn' : 'disabled-btn'}
                            label={'Save'}
                            handleClick={handleSkillSubmission}
                            customStyle={{ border: '1px solid lightgrey' }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
